import { useCallback, useEffect, useMemo, useState } from 'react'

export const useAddToHomeScreen = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  const [isPromptShown, setIsPromptShown] = useState(false)

  useEffect(() => {
    let int: NodeJS.Timeout | null = setInterval(() => {
      if (window && window.AddToHomeScreenInstance) {
        setIsLoaded(true)
        if (int) clearInterval(int)
        int = null
      }
    }, 300)
    return () => {
      if (int) clearInterval(int)
    }
  }, [])

  const showPrompt = useCallback(() => {
    if (isLoaded) {
      if (!document.querySelector('.adhs-container')) {
        window.AddToHomeScreenInstance.show('en')
        setIsPromptShown(true)
      }
    }
  }, [isLoaded])

  const isStandAlone = useMemo(() => {
    if (!isLoaded) return false
    return window.AddToHomeScreenInstance.isStandAlone()
  }, [isLoaded])

  const canBeInstalled = useMemo(() => {
    if (!isLoaded) return false
    const instance = window.AddToHomeScreenInstance
    return (
      instance.isStandAlone() ||
      instance.isBrowserIOSSafari() ||
      instance.isBrowserIOSChrome() ||
      instance.isBrowserAndroidChrome() ||
      instance.isDesktopSafari() ||
      instance.isDesktopChrome() ||
      instance.isDesktopEdge()
    )
  }, [isLoaded])

  return {
    isLoaded,
    showPrompt,
    isStandAlone,
    canBeInstalled,
    isPromptShown,
  }
}
